import { Routes, RouterModule } from '@angular/router';

//Route for content layout without sidebar, navbar and footer for users like Login, Registration etc...

export const CONTENT_ROUTES: Routes = [
     {
        path: '',
        loadChildren: () => import('../../users/content-pages/content-pages.module').then(m => m.ContentPagesModule)
    }
];
